import { createRoute, redirect } from '@tanstack/react-router';
import { Route as RootRoute } from './__root';

/** The module's home is its first tab, Rezervace; the fleet lives at `/pujcovna/vozidla`. */
export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/pujcovna',
  beforeLoad: () => {
    throw redirect({ to: '/pujcovna/rezervace', replace: true });
  },
});
